export default __webpack_public_path__ + "static/media/oops.01f2818e.jpg";